import React,{useEffect} from 'react';
import { ButtonGroup, Button,TextField,FormControl,Select,MenuItem} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const Rating = ({ index, options, handleRatingChange, rating,type,handleTextCombo }) => {
  const { t } = useTranslation();
  const location = window.location.href
  const matches = useMediaQuery("(min-width:600px)");
  const [text, setText] = React.useState(rating);
  const [date, setDate] = React.useState(location.includes("deg") ? dayjs() : null);
  const [combo, setCombo] = React.useState(-1);
  const handleChange = (index,e) => {
    setText(e.target.value);
    handleRatingChange(index, {id:0,description:e.target.value});
  };
  const handleChangeCombo = (index,e) => {
    const comboValue = e.target.value
    handleTextCombo(comboValue)
    setCombo(comboValue);
    handleRatingChange(index, { id: comboValue,description:""});
  };
  const handleChangeDate = (date,index) => {
    setDate(date);
    handleRatingChange(index, {id:0,description:date.format('DD/MM/YYYY')});
  };
  


  useEffect(() => {
    let ignore = false;
    
    if (!ignore && location.includes("deg"))  handleChangeDate(dayjs(),index)
    return () => { ignore = true; }
    },[]);


    
  
  return (
    <>
    {(() => {
        switch (type) {
          case 'radio':
            return <ButtonGroup variant="outlined" color="primary" orientation={`${matches ? `horizontal` : `vertical`}`} sx={{width:"100%"}}>
                      {options.map((option) => (
                        <Button
                          key={option.id}
                          onClick={() => handleRatingChange(index, option)}
                          variant={rating === option.description ? 'contained' : 'outlined'}
                        >
                          {t(option.description)}
                        </Button>
                      ))}
                    </ButtonGroup>;
          case 'text':
            return <TextField
            multiline
            value={text}
            defaultValue={rating}
            placeholder={t("Inserisci qui il commento...")}
            minRows={2}
            onChange={(e) => handleChange(index,e)}
            sx={{width:"100%"}}
          />;
          case 'combo':
            return <FormControl fullWidth>
            <Select
              value={combo}
              onChange={(e) => handleChangeCombo(index,e)}
              id={`combo-${index}`} 
            >
            {options.map((option) => (
              option.id === -2 || option.id === -3 ? <MenuItem value={option.id} disabled sx={{ color: 'blue' }}>{t(option.description)+':'}</MenuItem> : <MenuItem value={option.id}>{t('options.'+option.id)}</MenuItem>
            ))}

            </Select>
          </FormControl>;
          case 'date':
            return <DatePicker
            format='DD/MM/YYYY'
            value={date}
            onChange={(date) => handleChangeDate(date,index)}
            sx={{width:"100%"}}
            label={t("Inserisci la data")}
            required
            maxDate={dayjs()}
            minDate={dayjs().subtract(1, 'year')}
            />; 
          default:
            return <div>Errore</div>
        }
      })()}
    </>
    
  );
};

export default Rating;
